export default __webpack_public_path__ + "static/media/img.d4888a27.png";